export default () => ({
    
    loadMember(event) {
        console.dir(event.target);
        if(event.target.localName == 'svg' || event.target.localName == 'path' || event.target.localName == 'a') {
        } else { 
          let member = event.target.closest('.member');
          this.img = member.querySelector('img').attributes.src.value;
          this.name = member.querySelector('.member_name').innerText;
          this.role = member.querySelector('.member_role').innerText;
          this.email = member.querySelector('.member_email a').innerText;
          this.linkedin = member.querySelector('.member_linkedin a').href;
          this.mailto = `mailto:${this.email}`;
          this.bio = member.dataset.bio;
          console.log(this.img);
          this.openModal();
        }
    }
    
})